export type CrmRow = {
  rowIndex: number;
  accountNumber: string;
  customerName: string;
  abn: string;
  acn: string;
  email: string;
  mobile: string;
  street: string;
  town: string;
  region: string;
  postcode: string;
  country: string;
  isActive: string;
  note: string;
};

export type DiffField =
  | 'name'
  | 'abn'
  | 'acn'
  | 'email'
  | 'mobile'
  | 'street'
  | 'town'
  | 'region'
  | 'postcode'
  | 'country'
  | 'isActive';

export type FieldDiff = {
  field: DiffField;
  current: string | null;
  proposed: string;
};

// A single per-row validation failure surfaced in the review grid + detail modal. The backend emits
// machine codes (not prose) — mirroring bulk meter upload — joined in failureReasonDetail; toUploadRow
// splits them into FormatErrors and the render surfaces translate each code via react-i18next
// (subscriber_sync_upload.modal.error.<code>), interpolating the offending value from rowData[field].
export type FormatErrorCode =
  | 'invalid_email'
  | 'invalid_abn_length'
  | 'invalid_abn_checksum'
  | 'invalid_acn_length'
  | 'invalid_mobile'
  | 'no_primary_user';

export type FormatError = {
  // The CRM field whose value the error refers to (used to interpolate the value), or '' when the
  // code carries no associated value (e.g. no_primary_user).
  field: DiffField | '';
  code: FormatErrorCode;
};

// Maps each format-error code to the CRM field whose value it concerns. Mirrors the backend's
// SubscriberSyncUploadService.FORMAT_ERROR_FIELD. Codes with no value map to ''.
export const FORMAT_ERROR_FIELD: Record<FormatErrorCode, DiffField | ''> = {
  invalid_email: 'email',
  invalid_abn_length: 'abn',
  invalid_abn_checksum: 'abn',
  invalid_acn_length: 'acn',
  invalid_mobile: 'mobile',
  no_primary_user: '',
};
